import { ProductType } from '@inter-ikea-storageone/range';

// This should not be needed. We should have a "rail" product type
export const allRailProductTypes = [
  ProductType.PAX_CLOTH_RAIL_350,
  ProductType.PAX_CLOTH_RAIL_580,
  ProductType.PAX_PULL_OUT_CLOTH_RAIL,
  ProductType.PLATSA_CLOTH_RAIL_40,
  ProductType.PLATSA_CLOTH_RAIL_55,
  ProductType.PLATSA_CLOTH_RAIL_55_W_HOOKS_ASM
];
